export interface AppConfig {
  apiUrl: string;
}

let _config: AppConfig | null = null;

export async function loadConfig(): Promise<AppConfig> {
  if (_config) return _config;
  const res = await fetch('/config.json');
  _config = await res.json();
  return _config!;
}
